import library from './leonLayers.json';

// A missing exact asset is unavailable, never another colour or ribbon.
export function leonLayerScene({front, back, ribbonFabric, view = 'front'}) {
  if (!['front', 'back'].includes(view)) return null;
  const bodyId = view === 'back' ? back?.option_id || library.defaultBack
    : front?.option_id || library.defaultFront;
  const body = library[view][bodyId];
  const ribbon = library.ribbons[ribbonFabric?.option_id];
  if (!body?.src || !ribbon?.src) return null;
  return {
    body: body.src,
    ribbon: ribbon.src,
    bodyId,
    ribbonId: ribbonFabric.option_id,
    bodyPlacement: {...library.bodyPlacement, ...body.placement},
    ribbonPlacement: {...library.ribbonPlacement, ...body.ribbonPlacement, ...ribbon.placement},
    junctionMask: body.junctionMask,
    junctionOverlay: body.junctionOverlay,
  };
}
